<section>
  <div class="container-fluid">
    <div class="py-3"></div>
    <form [formGroup]="newProduct" (ngSubmit)="onSubmit()">

      <!-- ================= PRODUCT DETAILS ================= -->
      <div class="row">

        <!-- CATEGORY -->
        <div class="col-lg-3 col-md-6 col-12 mb-3">
          <div class="form-floating">
            <select class="form-select" formControlName="categoryId" (change)="onSelectCategory($event)">
              <option value="" disabled>Select Category</option>
              <option *ngFor="let cat of categoryDetails" [value]="cat.categoryId">
                {{ cat.categoryName }}
              </option>
            </select>
            <label>Category <span class="text-danger">*</span></label>
          </div>
          <span class="text-danger" *ngIf="isInvalid(newProduct.get('categoryId'))">
            Category Name is required
          </span>
        </div>

        <!-- SUB CATEGORY -->
        <div class="col-lg-3 col-md-6 col-12 mb-3">
          <div class="form-floating">
            <select class="form-select" formControlName="subCategoryId" (change)="onSelectSubCategory($event)">

              <option value="">Select Sub Category</option>

              <option *ngFor="let sub of filteredSubCategories" [value]="sub.subCategoryId">
                {{ sub.subCategoryName }}
              </option>

            </select>
            <label>Sub Category</label>
          </div>
        </div>


        <!-- PRODUCT NAME -->
        <div class="col-lg-3 col-md-6 col-12 mb-3">
          <div class="form-floating">
            <input class="form-control" formControlName="productName">
            <label>Product Name <span class="text-danger">*</span></label>
          </div>
          <span class="text-danger" *ngIf="isInvalid(newProduct.get('productName'))">
            Product Name is required
          </span>
        </div>

        <!-- YOUTUBE -->
        <div class="col-lg-3 col-md-6 col-12 mb-3">
          <div class="form-floating">
            <input class="form-control" formControlName="youtubeLink">
            <label>YouTube Link</label>
          </div>
          <small class="text-danger" *ngIf="isInvalidError('youtubeLink')">
            Invalid YouTube URL
          </small>
        </div>



        <!-- ================= COD (PRODUCT LEVEL) ================= -->

        <div class="col-lg-3 col-md-6 col-12 mb-3">
          <div class="form-floating">
            <select class="form-select" formControlName="isLive">
              <option value="">Select Live Sale</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <label>Live Sale</label>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 col-12 mb-3">
          <div class="form-floating">
            <input type="tel" class="form-control" formControlName="hsnCode" maxlength="8">
            <label>HsnCode <span class="text-danger">*</span></label>
            <span class="text-danger" *ngIf="isInvalid(newProduct.get('hsnCode'))">
              HsnCode is required
            </span>
          </div>
        </div>

        <!-- DESCRIPTION -->
        <div class="col-lg-6 col-md-12 col-12 mb-3">
          <div class="form-control quill-height mb-3">
            <label for="productDescription">Product Description <span class="text-danger">*</span></label>
            <div class="">
              <quill-editor class="quill-editor" formControlName="description"
                (onContentChanged)="onContentChanged($event)" [modules]="editorModules"> </quill-editor>
            </div>
            <span class="text-danger" *ngIf="isInvalid(newProduct.get('description'))">
              Description is required
            </span>
          </div>
        </div>
      </div>

      <!-- ================= DISCOUNTS (PRODUCT LEVEL) ================= -->
      <div class="border rounded p-3 mt-4" formArrayName="discounts">

        <div class="d-flex justify-content-between mb-2">
          <h6>Discount Details</h6>
          <button type="button" class="btn btn-sm btn-primary" (click)="addDiscount()">
            + Add Discount
          </button>
        </div>

        <div class="row fw-semibold mb-2" *ngIf="discounts.controls.length">
          <div class="col-md-4">Qty</div>
          <div class="col-md-4">Amount</div>
          <div class="col-md-2">Action</div>
        </div>

        <div class="row g-2 align-items-center" *ngFor="let d of discounts.controls; let i = index" [formGroupName]="i">

          <div class="col-md-4 mb-2">
            <input class="form-control" type="tel" formControlName="discountQuantity" min="0"
              (keypress)="allowOnlyNumbers($event)">
          </div>

          <div class="col-md-4 mb-2">
            <input class="form-control" type="tel" formControlName="discountAmount" min="0"
              (keypress)="allowOnlyNumbers($event)">
          </div>

          <div class="col-md-2 mb-2">
            <button type="button" class="btn btn-danger btn-sm w-100" (click)="removeDiscount(i)">
              Remove
            </button>
          </div>

        </div>
      </div>

      <!-- ================= VARIANTS ================= -->
      <div class="d-flex justify-content-end my-3 gap-2">
        <button type="button" class="btn btn-outline-primary" (click)="onAddVariantClick()">
          + Add Variant
        </button>

        <button type="button" class="btn btn-outline-success" (click)="bulkVariantClick()">
          + Bulk Variant
        </button>
      </div>

      <div formArrayName="variants">

        <div class="card shadow-lg border-0 mb-4 mt-2" *ngFor="let v of variants.controls; let i = index"
          [formGroupName]="i">

          <div class="card-header d-flex justify-content-between align-items-center">
            <h6 class="fw-bold mb-0">Variant {{ i + 1 }}</h6>
            <button type="button" class="btn btn-danger btn-sm" [disabled]="variants.length === 1"
              (click)="deleteVariant(i)">
              Delete Variant
            </button>
          </div>

          <div class="card-body">
            <div class="row g-3">

              <div class="col-md-3">
                <label>Barcode <span class="text-danger">*</span></label>
                <input class="form-control" formControlName="barcodeNumber">
                <span class="text-danger" *ngIf="isInvalid(v, 'barcodeNumber')">
                  Barcode Number is required
                </span>
              </div>

              <div class="col-md-3">
                <label>Size <span class="text-danger">*</span></label>
                <select class="form-control" formControlName="size">
                  <option value="">Select</option>
                  <option *ngFor="let s of sizeList" [value]="s.label">
                    {{ s.label }}
                  </option>
                </select>
                <span class="text-danger" *ngIf="isInvalid(v, 'size')">
                  Size is required
                </span>
              </div>

              <div class="col-md-2">
                <label>Qty <span class="text-danger">*</span></label>
                <input type="tel" class="form-control" formControlName="varientQuantity" min="0"
                  (keypress)="allowOnlyNumbers($event)">
                <span class="text-danger" *ngIf="isInvalid(v, 'varientQuantity')">
                  Quantity must be greater than 0
                </span>
              </div>

              <div class="col-md-2">
                <label>SRP <span class="text-danger">*</span></label>
                <input type="tel" class="form-control" formControlName="productSrp" min="0"
                  (keypress)="allowOnlyNumbers($event)">
                <span class="text-danger" *ngIf="isInvalid(v, 'productSrp')">
                  SRP must be greater than 0
                </span>
              </div>

            </div>

            <!-- IMAGES -->
            <div class="mt-3">
              <label>Images <span class="text-danger">*</span></label>
              <input type="file" multiple class="form-control" (change)="onFileSelected($event, i)">

              <!-- Image validation error -->
              <small class="text-danger" *ngIf="hasImageError(getVariantGroup(i))">
                Variant {{ i + 1 }}: Select a primary image
              </small>

              <!-- Preview -->
              <div class="d-flex mt-2 gap-2 flex-wrap">

                <div *ngFor="let imgCtrl of getImagesArray(i).controls; let j = index"
                  class="position-relative text-center">

                  <img [src]="getImagePreview(imgCtrl)" width="80" height="80" class="rounded border"
                    [class.border-success]="imgCtrl.get('isPrimary')?.value" style="object-fit: cover" />

                  <div class="mt-1 d-flex flex-column gap-1">

                    <button type="button" class="btn btn-sm btn-success" (click)="setPrimaryImage(i, j)"
                      [disabled]="imgCtrl.get('isPrimary')?.value">
                      Set Primary
                    </button>

                    <button type="button" class="btn btn-sm btn-danger" [disabled]="getImagesArray(i).length === 1"
                      (click)="removeImage(i, j)">
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>

      <!-- ================= SAVE ================= -->
      <div class="text-center my-4">
        <button class="btn btn-success btn-lg" type="submit">
          {{ isUpdate ? 'Update Product' : 'Save Product' }}
        </button>
      </div>

    </form>
  </div>
</section>

<!-- NORMAL ANGULAR POPUP -->
<div
  class="modal-wrapper bulk-variant-modal"
  role="dialog"
  aria-modal="true"
  *ngIf="showVariantPopup"
>
  <div
    class="modal-content bulk-variant-modal-content p-4 rounded shadow-lg"
    (click)="$event.stopPropagation()"
  >

    <!-- HEADER -->
    <div class="modal-header d-flex justify-content-between align-items-center mb-3">
      <h5 class="modal-title fw-bold mb-0">
        Bulk Add Variants
      </h5>

      <button
        type="button"
        class="btn-close"
        (click)="cancelVariantPopup()">
      </button>
    </div>

    <!-- BODY -->
    <div class="modal-body">

      <div class="row g-4">

        <!-- CHARACTER NAME -->
        <div class="col-xl-6 col-lg-6 col-md-6 col-12">

          <label class="form-label fw-semibold">
            Character Name / Prefix
            <span class="text-danger">*</span>
          </label>

          <input
            type="text"
            class="form-control form-control-lg"
            [(ngModel)]="bulkCharacterName"
            placeholder="Example: SAREE"
            maxlength="20"
            autocomplete="off"
          />

          <small
            class="text-danger"
            *ngIf="bulkSubmitted && !bulkCharacterName?.trim()">
            Character Name is required.
          </small>

        </div>

        <!-- SRP -->
        <div class="col-xl-6 col-lg-6 col-md-6 col-12">

          <label class="form-label fw-semibold">
            SRP
            <span class="text-danger">*</span>
          </label>

          <input
            type="tel"
            class="form-control form-control-lg"
            [(ngModel)]="bulkSrp"
            placeholder="Example: 599"
            min="1"
            (keypress)="allowOnlyNumbers($event)"
          />

          <small
            class="text-danger"
            *ngIf="bulkSubmitted && (!bulkSrp || +bulkSrp <= 0)">
            SRP must be greater than 0.
          </small>

        </div>

        <!-- START NUMBER -->
        <div class="col-xl-6 col-lg-6 col-md-6 col-12">

          <label class="form-label fw-semibold">
            Starting Number
            <span class="text-danger">*</span>
          </label>

          <input
            type="tel"
            class="form-control form-control-lg"
            [(ngModel)]="bulkStartNumber"
            placeholder="Example: 1001"
            min="1"
            (keypress)="allowOnlyNumbers($event)"
            (input)="validateBulkRange()"
          />

          <small
            class="text-danger"
            *ngIf="
              bulkSubmitted &&
              (!bulkStartNumber || +bulkStartNumber <= 0)
            ">
            Starting Number must be greater than 0.
          </small>

        </div>

        <!-- END NUMBER -->
        <div class="col-xl-6 col-lg-6 col-md-6 col-12">

          <label class="form-label fw-semibold">
            Ending Number
            <span class="text-danger">*</span>
          </label>

          <input
            type="tel"
            class="form-control form-control-lg"
            [(ngModel)]="bulkEndNumber"
            placeholder="Example: 1010"
            min="1"
            (keypress)="allowOnlyNumbers($event)"
            (input)="validateBulkRange()"
          />

          <small
            class="text-danger"
            *ngIf="
              bulkSubmitted &&
              (!bulkEndNumber || +bulkEndNumber <= 0)
            ">
            Ending Number must be greater than 0.
          </small>

        </div>

      </div>

      <!-- RANGE ERROR -->
      <div
        class="alert alert-danger mt-4 mb-0"
        *ngIf="bulkRangeErrorMessage"
      >
        <strong>Error:</strong>
        {{ bulkRangeErrorMessage }}
      </div>

      <!-- TOTAL -->
      <div
        class="alert alert-info mt-4 mb-0"
        *ngIf="
          bulkVariantTotal > 0 &&
          !bulkRangeErrorMessage
        "
      >
        <strong>Total Variants:</strong>
        {{ bulkVariantTotal }}
      </div>

      <!-- PREVIEW -->
      <div
        class="border rounded p-4 mt-4"
        *ngIf="
          bulkCharacterName?.trim() &&
          bulkStartNumber &&
          bulkEndNumber &&
          bulkSrp &&
          !bulkRangeErrorMessage
        "
      >

        <h6 class="fw-bold mb-3">
          Variant Preview
        </h6>

        <div class="row">

          <div class="col-xl-4 col-md-4 col-12 mb-3">

            <small class="text-muted">
              First Barcode
            </small>

            <div class="fs-5 fw-bold">
              {{ bulkCharacterName | uppercase }}{{ bulkStartNumber }}
            </div>

          </div>

          <div class="col-xl-4 col-md-4 col-12 mb-3">

            <small class="text-muted">
              Last Barcode
            </small>

            <div class="fs-5 fw-bold">
              {{ bulkCharacterName | uppercase }}{{ bulkEndNumber }}
            </div>

          </div>

          <div class="col-xl-4 col-md-4 col-12 mb-3">

            <small class="text-muted">
              SRP
            </small>

            <div class="fs-5 fw-bold">
              ₹{{ bulkSrp }}
            </div>

          </div>

        </div>

      </div>

    </div>

    <!-- FOOTER -->
    <div
      class="modal-footer d-flex justify-content-end gap-2 mt-4"
    >

      <button
        type="button"
        class="btn btn-secondary btn-lg"
        (click)="cancelVariantPopup()"
      >
        Cancel
      </button>

      <button
        type="button"
        class="btn btn-primary btn-lg"
        [disabled]="!!bulkRangeErrorMessage"
        (click)="confirmBulkVariant()"
      >
        Generate
        <span *ngIf="bulkVariantTotal > 0">
          {{ bulkVariantTotal }}
        </span>
        Variants
      </button>

    </div>

  </div>
</div>